// extracted by mini-css-extract-plugin
export default {"mobileCheckoutWrapper":"sbXqXd","mobileCheckoutHeader":"txI9ck","mobileCheckoutDivider":"_1aiENB"};